import { render, staticRenderFns } from "./WelcomeLocation.vue?vue&type=template&id=8d1cf114&"
import script from "./WelcomeLocation.vue?vue&type=script&lang=js&"
export * from "./WelcomeLocation.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeLocation.vue?vue&type=style&index=0&id=8d1cf114&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports